import React from 'react';
import styles from './Paddle.module.css';

const Paddle = ({ username, name, nickname, email, items }) => {
  const fields = items ?? [
    { label: 'Username', value: username || '—' },
    { label: 'Name', value: name || '—' },
    { label: 'Nickname', value: nickname || '—' },
    { label: 'Email', value: email || '—' },
  ];

  return (
    <div className={styles.paddle}>
      <div className={styles.blade}>
        <div className={styles.info}>
          {fields.map((f, i) => (
            <React.Fragment key={i}>
              {i > 0 && <div className={styles.divider} />}
              <div className={styles.field}>
                <span className={styles.label}>{f.label}</span>
                <span className={styles.value}>{f.value}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Paddle;
